import { useEffect, useState, useCallback } from "react";

const KEY = "loretta_grocery";
const EVT = "loretta-grocery-change";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function write(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
}

export function addGroceryItems(items) {
  const list = read();
  const existing = new Set(list.map((i) => i.text.toLowerCase().trim()));
  const additions = items
    .map((t) => (typeof t === "string" ? t.trim() : ""))
    .filter((t) => t && !existing.has(t.toLowerCase()))
    .map((t) => ({ id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, text: t, checked: false }));
  write([...list, ...additions]);
  return additions.length;
}

export function useGrocery() {
  const [list, setList] = useState(read());

  useEffect(() => {
    const handler = () => setList(read());
    window.addEventListener(EVT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(EVT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const toggle = useCallback((id) => {
    write(read().map((i) => (i.id === id ? { ...i, checked: !i.checked } : i)));
  }, []);
  const remove = useCallback((id) => write(read().filter((i) => i.id !== id)), []);
  const clear = useCallback(() => write([]), []);
  const clearChecked = useCallback(() => write(read().filter((i) => !i.checked)), []);

  return { list, toggle, remove, clear, clearChecked };
}
